import { RoomTypeClassStateInterface } from '.';

function state(): RoomTypeClassStateInterface {
  return {
    roomTypeClasses: [],
  };
}

export default state;
